import { graphql, useLazyLoadQuery } from 'react-relay';
import { usePermissionsQuery } from './__generated__/usePermissionsQuery.graphql';

export default function usePermissions() {
    const { currentIAMUser } = useLazyLoadQuery<usePermissionsQuery>(
        graphql`
            query usePermissionsQuery {
                currentIAMUser {
                    isIAMUser
                    permissions
                }
            }
        `,
        {},
        {
            fetchPolicy: 'store-or-network'
        }
    );

    return {
        currentIAMUser,
        isAllowed: (requiredPermissions?: string[]) =>
            !currentIAMUser.isIAMUser || requiredPermissions === undefined || requiredPermissions.every((x) => currentIAMUser.permissions.includes(x))
    };
}
